import { render } from "./BaseColorPicker.vue?vue&type=template&id=64875542&scoped=true"
import script from "./BaseColorPicker.vue?vue&type=script&lang=js"
export * from "./BaseColorPicker.vue?vue&type=script&lang=js"

import "./BaseColorPicker.vue?vue&type=style&index=0&id=64875542&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64875542"]])

export default __exports__